module.exports = __webpack_public_path__ + "img/thumb_21.79d42fbc.jpg";